import { render, staticRenderFns } from "./CohortViewUserInfoCard.vue?vue&type=template&id=131bf2d1&scoped=true&"
import script from "./CohortViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./CohortViewUserInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./CohortViewUserInfoCard.vue?vue&type=style&index=0&id=131bf2d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131bf2d1",
  null
  
)

export default component.exports